var map = {
	"./chevron-up.svg": "94a4",
	"./copy-icon.svg": "54dc",
	"./document-add-icon.svg": "2955",
	"./downloads/android.svg": "2d41",
	"./downloads/mac.svg": "4a18",
	"./downloads/web.svg": "49c7",
	"./downloads/windows.svg": "e171",
	"./filter-icon.svg": "0c7a",
	"./info-circle-icon.svg": "f63f",
	"./mail-icon.svg": "c24c",
	"./register/ibtRegister-complete-icon.svg": "66b4",
	"./register/ibtRegister-financial-icon.svg": "c8bb",
	"./register/ibtRegister-poa-icon.svg": "9869",
	"./register/ibtRegister-poi-icon.svg": "2608",
	"./register/popular-frame.svg": "beac",
	"./register/register-deposit-icon.svg": "1cad",
	"./register/register-mt-account-icon.svg": "5c30",
	"./register/register-trade-icon.svg": "68051",
	"./register/register-withdrawal-icon.svg": "f9e7",
	"./reset-bal-icon.svg": "9bf1",
	"./setting-icon.svg": "bd52",
	"./tick-circle-icon.svg": "eab9",
	"./timer-icon.svg": "241c5",
	"./unlock-icon.svg": "df4f",
	"./user-icon.svg": "2272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";